import {peoplePropertiesClient} from 'common/report/queries/query-api/people-properties-client';

import {Store} from './store';

export const peoplePropertiesStore = new Store<Array<Record<string, any>>>({
  apiClient: peoplePropertiesClient,
  defaultValue: [],
  name: `people-properties`,
});
